export const DownloadEnum = {
    DOWNLOAD_COMPLETE: "DOWNLOAD_COMPLETE",
    FILE_EXISTS: "FILE_EXISTS",
    FILE_NOT_IN_LOCAL: "FILE_NOT_IN_LOCAL",
    DOWNLOAD_ERROR: "DOWNLOAD_ERROR",
    SPACE_AVAILABLE: "SPACE_AVAILABLE",
    SPACE_NOT_AVAILABLE: "SPACE_NOT_AVAILABLE",
    DELETE_SUCCESS: "DELETE_SUCCESS",
    DELETE_ERROR: "DELETE_ERROR",
    DOWNLOAD_CANCELED: "DOWNLOAD_CANCELED",
    DOWNLOAD_CANCELED_ERROR: "DOWNLOAD_CANCELED_ERROR",
    CONTINUE_DOWNLOAD: "CONTINUE_DOWNLOAD",
    GOTO_NEXT_ARTWORK: "GOTO_NEXT_ARTWORK",
    SHOW_STILL_IMAGE: "SHOW_STILL_IMAGE",
    CACHE_CLEAR_SUCCESS: "CACHE_CLEAR_SUCCESS",
    CACHE_CLEAR_ERROR: "CACHE_CLEAR_ERROR",
    SPACE_FREED: "SPACE_FREED",
    SPACE_NOT_FREED: "SPACE_NOT_FREED"
}

// 200 MB — minimum free storage floor
export const MIN_FREE_STORAGE_MB = 200;

export const USB_NAME = {
    usb1: "usb:1",
    usb2: "usb:2",
    usb3: "usb:3",
    usb4: "usb:4"
}

export const USB_NAME_PLAY_PATH = {
    usb1: "usb/1",
    usb2: "usb/2",
    usb3: "usb/3",
    usb4: "usb/4"
}